// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "coordinateControl-EKz_";
var _3 = "#575757";
var _4 = "disabled-OGj8";
var _5 = "1.5rem";
var _6 = "#dedede";
var _7 = "#adf";
var _8 = "1rem";
var _9 = "#bebebe";
var _a = ".8rem";
var _b = "#000";
export { _1 as "busBlue", _2 as "coordinateControl", _3 as "darkGrey", _4 as "disabled", _5 as "extraLargeFontSize", _6 as "lightGrey", _7 as "lightblue", _8 as "mediumFontSize", _9 as "mediumLightGrey", _a as "smallFontSize", _b as "unusedNodeColor" }
